import { useRefetchMerchantOnStageChange } from '@/components/loan-process/hooks/use-refetch-merchant-on-stage-change';

import { ApplicationNegative } from './application-negative/application-negative';

export function StageSeven() {
  useRefetchMerchantOnStageChange();

  return <ApplicationNegative />;
}
